import {
    setImageObj,
    setShowVideo
} from "./images.reducers";

export const setImage = url => dispatch => (
    dispatch(setImageObj(url))
);

export const updateShowVideo = url => dispatch => (
    dispatch(setShowVideo(url))
);

